<template>
  <v-chip label x-small :color="color" text-color="white" class="font-weight-bold px-2">
    {{ params.value }}
  </v-chip>
</template>
<script>
export default {
  computed: {
    color() {
      const colors = {
        Assigned: "grey darken-1",
        Active: "blue darken-1",
        Completed: "green darken-1",
      };
      return colors[this.params.value] || "grey";
    },
  },
};
</script>
